module.exports = __webpack_public_path__ + "static/media/light-bg.ce18751e.svg";